import * as React from 'react';

import { UseFormReturn } from 'react-hook-form';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@mui/material';

import { EditLiveInfoModalProps, EditLiveInfoModalState } from './models';
import { t, Trans } from "@lingui/macro";
import * as Yup from "yup";
import { withUseFormHook } from '@sinossi/mates-react-library';
import { selectDescriptionByLanguage } from 'utils';
import { ZPlayDateTimePicker, ZPlayFormField } from 'commons/fields';


const DetailFormSchema = Yup.object().shape({
    title:Yup.string()
});

class EditLiveInfoModal extends React.Component<EditLiveInfoModalProps & UseFormReturn, EditLiveInfoModalState>
{
    public constructor(props: any) {
        super(props)
    }

    componentDidMount(): void {
        this.props.setValue("title", selectDescriptionByLanguage(this.props.liveInfo.title, this.props.liveInfo.language));
        this.props.setValue("eventStartDateTime", this.props.liveInfo.liveAdditionalInfos?.eventStartDateTime);
        this.props.setValue("eventEndDateTime", this.props.liveInfo.liveAdditionalInfos?.eventEndDateTime);
    }

    successCallback = () => {
    }

    errorCallback = (err: any) => {
        console.log(err)
    }

    private submitForm = (values: any) => {
      
        if(values.title === "")
            values.title = this.props.liveInfo.title
        if(new Date(values.eventStartTime) !== this.props.liveInfo.liveAdditionalInfos!.eventStartDateTime){
           
            let startTime = new Date (this.props.liveInfo.liveAdditionalInfos!.eventStartDateTime)
            let endTime = new Date (this.props.liveInfo.liveAdditionalInfos!.eventEndDateTime)
            let diffMs = (endTime.getTime() - startTime.getTime())
            
            values.eventEndDateTime = new Date(values.eventStartDateTime).getTime() + (diffMs)
            this.props.liveInfo.liveAdditionalInfos!.eventEndDateTime = values.eventEndDateTime
        }

        let data = {
            title: values.title,
            eventStartDateTime: new Date(values.eventStartDateTime).toISOString(),
            eventEndDateTime: new Date(values.eventEndDateTime).toISOString(),
        };

        this.props.editLiveInfo(data, this.successCallback, this.errorCallback)
        this.props.closeEditLiveInfoModal()
    };

    render() {

        return (
            <Dialog
                open={this.props.showEditLiveInfoModal}
                onClose={() => this.props.closeEditLiveInfoModal()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ style: { background: "#1d1c25" } }}>
                <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                    <DialogTitle style={{ color: "white" }} id="alert-dialog-title">
                        <Trans id="elim-title">Modifica info live</Trans>
                    </DialogTitle>
                    <DialogContent>
                        <ZPlayFormField
                            name="title"
                            label={t({
                                id: "df-title",
                                message: "Titolo"
                            })}
                            required={true}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                        />
                        <ZPlayDateTimePicker
                            name="eventStartDateTime"
                            label={t({
                                id: "df-event-date",
                                message: "Data inizio evento",
                            })}
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}
                        />
                        <ZPlayDateTimePicker
                            name="eventEndDateTime"
                            label={t({
                                id: "df-event-end-date",
                                message: "Data fine evento",
                            })}
                            disabled={true}
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}
                        />

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.props.closeEditLiveInfoModal()}
                            style={{ color: "white" }}>Indietro</Button>
                        <Button
                            variant="contained" type='submit' autoFocus
                            style={{ backgroundColor: "#920073" }}>
                            Conferma
                        </Button>
                    </DialogActions>
                </form>
            </Dialog >
        )
    };
} export default withUseFormHook(
    EditLiveInfoModal,
    DetailFormSchema
)